import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/class-control";
import type { NotificationStatus } from "@/interfaces/notification.interface";

const notificationStatusBadgeVariants = cva(
  "flex items-center justify-center rounded-[20px] h-[39px] w-[120px] font-['Plus_Jakarta_Sans'] font-normal text-[16px] text-center",
  {
    variants: {
      status: {
        Pendente: "bg-[#DC4426] text-[#FEF4F2]",
        Lida: "bg-[#13D480] text-[#F5F2FF]",
      },
    },
    defaultVariants: {
      status: "Pendente",
    },
  }
);

export interface NotificationStatusBadgeProps
  extends VariantProps<typeof notificationStatusBadgeVariants> {
  status: NotificationStatus;
  className?: string;
}

export function NotificationStatusBadge({
  status,
  className,
}: NotificationStatusBadgeProps) {
  return (
    <div className={cn(notificationStatusBadgeVariants({ status }), className)}>
      <p className="whitespace-pre">{status}</p>
    </div>
  );
}
